const numeralRegex = /[\u0660-\u0669\u06f0-\u06f9]/g;
export const ConvertToEnglish = (input) =>
  input.replace(numeralRegex, (match) => {
    const code = match.charCodeAt(0);
    if (code >= 0x0660 && code <= 0x0669) {
      return String.fromCharCode(code - 0x0660 + 48);
    } else if (code >= 0x06f0 && code <= 0x06f9) {
      return String.fromCharCode(code - 0x06f0 + 48);
    }
  });
